export default __webpack_public_path__ + "static/media/Results-2.ab30eee8.png";